/**
 * Default event name used for component viewed events
 */ export const COMPONENT_VIEWED_EVENT_NAME = '[Chegg] Component Viewed';
/**
 * Prefix used for all Amplitude-related event names and properties
 * This matches Amplitude's DEFAULT_EVENT_PREFIX constant
 * @see https://github.com/amplitude/Amplitude-TypeScript/blob/main/packages/analytics-browser/src/constants.ts
 */ export const AMPLITUDE_EVENT_PREFIX = '[Amplitude]';
/**
 * Default event name used for page viewed events
 *
 * This matches Amplitude's DEFAULT_PAGE_VIEW_EVENT constant
 * @see https://github.com/amplitude/Amplitude-TypeScript/blob/main/packages/analytics-browser/src/constants.ts
 */ export const PAGE_VIEWED_EVENT_NAME = `${AMPLITUDE_EVENT_PREFIX} Page Viewed`;
/**
 * Constant for Amplitude viewport height property
 */ export const AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT = `${AMPLITUDE_EVENT_PREFIX} Viewport Height`;
/**
 * Constant for Amplitude viewport width property
 */ export const AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH = `${AMPLITUDE_EVENT_PREFIX} Viewport Width`;
